export const downloadPopup = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 22V20H20V22H4ZM12 18L5 9H9V2H15V9H19L12 18ZM12 14.75L14.9 11H13V4H11V11H9.1L12 14.75Z"
      fill="#EDEDED"
    />
  </svg>
);
